import * as React from "react";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { CurrentViewContext } from "../../../ComponentWithContext";
import { DummyCardTabs } from "../CardTemplate/DummyCardContent";
import { MyServicesCardHeader } from "../CardTemplate/myServicesCardHeader";
import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import { Button } from "@ssce/ui-shared-library";

const OracleReport: React.FC = () => {
  const navigate = useNavigate();
  const { viewData } = useContext(CurrentViewContext);

  return (
    <>
      <MyServicesCardHeader
        imageSource={"/api/assets/Oracle.png"}
        title={"Oracle"}
        subTitle={`Oracle, ${viewData.region}`}
        contents={
          "Oracle Database 23ai is designed to seamlessly integrate AI capabilities directly into the database, allowing organizations to power AI-driven applications more efficiently and manage mission-critical workloads with enhanced performance. It ensures applications run with high availability, security, and scalability, making it a comprehensive solution for modern data management challenges."
        }
        tags={[
          {
            label: "Data Management",
            style: { backgroundColor: "#E7F3F9", color: "#0A85C7" },
          },
          {
            label: "Analytics",
            style: { backgroundColor: "#EFE6FD", color: "#6200EE" },
          },
          {
            label: "Cross-Industry",
            style: { backgroundColor: "#FFE5F0", color: "#D72F77" },
          },
        ]}
      >
        <Button
          variant="secondary"
          id={"getSupport"}
          onClick={() => navigate("/support")}
        >
          Get Support
          <ContactSupportIcon />
        </Button>
      </MyServicesCardHeader>
      <DummyCardTabs
        title={"Oracle"}
        instanceName={"Oracle Database 23ai"}
        subscriptionName={"Oracle"}
      />
    </>
  );
};
export default OracleReport;
